var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pattern-category",class:{'cluster': _vm.format == 'cluster'},style:({'background-color': `#${_vm.category.backgroundColor}`}),on:{"click":function($event){return _vm.$emit('select', _vm.category)}}},[_c('h3',{style:({'color': `#${_vm.category.textColor}`})},[_vm._v(" "+_vm._s(_vm.category.name)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }